import React from "react";

const CollapsibleCardHeader = ({ id, name, target }) => {
  return (
    <div className="card-header" id={id}>
      <div
        className="card-title collapsed bg-gray-300"
        data-toggle="collapse"
        data-target={`#${target}`}
      >
        {name}
      </div>
    </div>
  );
};
export default CollapsibleCardHeader;
